import React, { useState, useEffect } from 'react';
import { Table, message, Spin } from 'antd';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { informacionsisben } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const SisvenComponente = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [chartDataGroups, setChartDataGroups] = useState(null);
    const [chartDataGender, setChartDataGender] = useState(null);

    useEffect(() => {
        if (municipioId) {
          fetchData();  
        }
        
    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await informacionsisben(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;

                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                    setFilteredData(fetchedData);
                    prepareChartData(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const prepareChartData = (data) => {
        if (data.length > 0) {
            const item = data[0];
            setChartDataGroups({
                labels: ['Grupo A', 'Grupo B', 'Grupo C', 'Grupo D'],
                datasets: [
                    {
                        data: [item.porc_grupoa, item.porc_grupob, item.porc_grupoc, item.porc_grupod],
                        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
                    },
                ],
            });
            setChartDataGender({
                labels: ['Hombres', 'Mujeres'],
                datasets: [
                    {
                        data: [item.porc_hombres, item.porc_mujeres],
                        backgroundColor: ['#FF6384', '#36A2EB'],
                    },
                ],
            });
        }
    };

    const columns = [
        {
            title: 'TOTAL SISBEN ',
            dataIndex: 'pers_total',
            key: 'pers_total',
            className: 'filaP',
            width: '6%',
            render: text => <span>{text}</span>,
        },
        {
            title: 'TOTAL HOMBRES SISBEN',
            dataIndex: 'porc_hombres',
            key: 'porc_hombres',
            className: 'filaP',
            width: '5%',
            render: text => <span>{text}</span>,
        },
        {
            title: 'TOTAL MUJERES SISBEN',
            dataIndex: 'porc_mujeres',
            key: 'porc_mujeres',
            className: 'filaP',
            width: '5%',
            render: text => <span>{text}</span>,
        },
        {
            title: 'NUMERO DE HOGARES',
            dataIndex: 'hog_total',
            key: 'hog_total',
            className: 'filaP',
            width: '5%',
            render: text => <span>{text}</span>,
        },
        {
            title: 'PROMEDIO DE PERSONAS POR HOGAR',
            dataIndex: 'promedio_personasxhogar',
            key: 'promedio_personasxhogar',
            className: 'filaP',
            width: '5%',
            render: text => <span>{text}</span>,
        },
        {
            title: 'VIVIENDAS',
            dataIndex: 'viviendas',
            key: 'viviendas',
            className: 'filaP',
            width: '5%',
            render: text => <span>{text}</span>,
        },
    ];

    const columnsSisbenIV = [
        {
            title: 'GRUPO A',
            dataIndex: 'total_sisbena',
            key: 'total_sisbena',
            className: 'filaP',
            width: '5%',
            render: text => <span>{text}</span>,
        },
        {
            title: 'GRUPO B',
            dataIndex: 'total_sisbenb',
            key: 'total_sisbenb',
            className: 'filaP',
            width: '5%',
            render: text => <span>{text}</span>,
        },
        {
            title: 'GRUPO C',
            dataIndex: 'total_sisbenc',
            key: 'total_sisbenc',
            className: 'filaP',
            width: '5%',
            render: text => <span>{text}</span>,
        },
        {
            title: 'GRUPO D',
            dataIndex: 'total_sisbend',
            key: 'total_sisbend',
            className: 'filaP',
            width: '5%',
            render: text => <span>{text}</span>,
        },
    ];

    return (
        <div className="page-content">
            <h3>1.5 Información del Sisbén </h3>
            {loading ? (
                <Spin size="large" />
            ) : (
                <div>
                    <div className="table-container">
                        <h4>SISBEN</h4>
                        <Table
                            columns={columns}
                            dataSource={filteredData}
                            pagination={false}
                            scroll={{ x: '100%' }}
                        />

                        <h4>GRUPOS SISBEN</h4>
                        <Table
                            columns={columnsSisbenIV}
                            dataSource={filteredData}
                            pagination={false}
                            scroll={{ x: '100%' }}
                        />
                    </div>
                    <div className="chart-containerSisben ">
                        <div className="chart-Sisben">
                            <h4>Porcentaje según grupo Sisbén</h4>
                            {chartDataGroups && <Pie data={chartDataGroups} />}
                        </div>

                        <div className="chart-Sisben">
                            <h4>Porcentaje según género</h4>
                            {chartDataGender && <Pie data={chartDataGender} />}
                        </div>  
                        </div>
                </div>
            )}
        </div>
    );
};

export default SisvenComponente;
